import * as React from 'react';
import { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import DocumentMenuListItem from './DocumentMenuListItem';
import ClickLayer from '../ClickLayer';
import { computed } from 'mobx';
import { DisplayOption } from '../../types';

// Drop Down
const DropDownDocumentList = styled<any, any>('ul')`
    ${propStyles};
    top: 100%;
    right: 0;
    margin: 0;
    padding: 0;
`;

DropDownDocumentList.defaultProps = {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    minWidth: '160px',
    maxWidth: '400px',
    maxHeight: '240px',
    overflowY: 'auto',
    bgColor: 'white',
    boxShadow: 'sm',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    zIndex: 'dropdown',
};

// Inline
const InlineDocumentList = styled<any, any>('ul')`
    ${propStyles};
`;

InlineDocumentList.defaultProps = {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 100%',
    flexWrap: 'wrap',
    margin: '1em 0 0 0',
    padding: '0px',
    listStyle: 'none',
};

interface DocumentMenuListTheme {
    DropDownDocumentList?: any;
    InlineDocumentList?: any;
    DocumentMenuListItem?: any;
}

interface DocumentMenuListProps {
    theme: any;
    documents: Array<any>;
    open?: boolean;
    showLabel?: boolean;
    showCheckbox?: boolean;
    refContent: any;
    top: string;
    right: string;
    displayOption?: DisplayOption;
    metricContext?: string;
    documentType?: string;
    entityWrapper?: any;
    toggleDropdown(): void;
    onChange?(document: any): void;
    selected?(clientCode: string): boolean;
}

@observer
class DocumentMenuList extends Component<DocumentMenuListProps> {
    @computed
    get theme() {
        const { theme } = this.props;
        const componentTheme: DocumentMenuListTheme = {};
        return { ...theme, ...componentTheme };
    }

    @computed
    get documentListItems() {
        const {
            theme,
            documents = [],
            showLabel = true,
            showCheckbox = false,
            metricContext,
            documentType,
            entityWrapper,
            onChange,
            selected,
        } = this.props;

        return documents.map(document => (
            <DocumentMenuListItem
                key={document.clientCode}
                document={document}
                showLabel={showLabel}
                showCheckbox={showCheckbox}
                onChange={onChange}
                selected={selected && selected(document.clientCode)}
                theme={theme}
                metricContext={metricContext}
                documentType={documentType}
                entityWrapper={entityWrapper}
                {...theme.DocumentListItem}
            />
        ));
    }

    render() {
        const {
            theme,
            open = false,
            toggleDropdown,
            refContent,
            top,
            right,
            displayOption = 'dropdown',
        } = this.props;

        const documentList =
            displayOption === 'dropdown' ? (
                <DropDownDocumentList
                    ref={refContent}
                    style={{ top, right }}
                    {...theme.DocumentList}
                >
                    {this.documentListItems}
                </DropDownDocumentList>
            ) : (
                <InlineDocumentList {...theme.DocumentList}>
                    {this.documentListItems}
                </InlineDocumentList>
            );
        return (
            open && (
                <Fragment>
                    {displayOption === 'dropdown' && (
                        <ClickLayer
                            onClick={e => {
                                e.stopPropagation();
                                toggleDropdown();
                            }}
                            data-metric-id={'documentMenuList-clickLayer'}
                        />
                    )}
                    {documentList}
                </Fragment>
            )
        );
    }
}

export default withTheme(DocumentMenuList) as any;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentMenuList.tsx